import { PillButton } from 'ui-kit/Buttons';

import RangeSliderV2 from './RangeSliderV2';
import { usePopout, FloatingPortal } from '../hooks/usePopout';

export function RangePillButton(props: {
  min: number;
  max: number;
  name: string;
  initialValue: [number, number];
  onChange?: (values: [number, number]) => void;
  iconName: string;
  onIconClick?: () => void;
  displayPercentage?: boolean;
  inputFormat?: (value: string) => number;
  integer?: boolean;
  decimal?: boolean;
  className?: string;
  displayFormat?: (value: number) => string;
}) {
  const { refs, getFloatingProps, getReferenceProps, isOpen, floatingStyles } = usePopout({
    offset: 2,
  });

  const displayFormat = props.displayFormat || ((value: number) => value.toString());
  const value = props.displayPercentage
    ? `${displayFormat(props.initialValue[0])}% to ${displayFormat(props.initialValue[1])}%`
    : `${props.initialValue[0]} to ${props.initialValue[1]}`;

  return (
    <>
      <PillButton
        {...getReferenceProps()}
        ref={refs.setReference}
        description={props.name}
        value={value}
        className={props.className || ''}
        iconName={props.iconName || 'pill-close'}
        iconOnClick={props.onIconClick}
      />

      {isOpen ? (
        <FloatingPortal>
          <div
            className="z-10 h-[90px] w-[298px] rounded-lg border  border-solid border-brand-500 bg-black p-4 pb-[22px]"
            ref={refs.setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
          >
            <RangeSliderV2
              defaultValue={props.initialValue}
              min={props.min}
              max={props.max}
              onChange={(sliderValues) => {
                props.onChange?.([sliderValues[0], sliderValues[1]]);
              }}
              displayFormat={displayFormat}
              inputFormat={props.inputFormat}
              displayPercentage={props.displayPercentage}
              integer={props.integer}
              decimal={props.decimal}
            />
          </div>
        </FloatingPortal>
      ) : null}
    </>
  );
}
